import { useAppQuery } from 'data/query-client';
import restClient from 'data/restClient';
import { useAuthToken } from 'hooks/useAuthToken';
import { AllessehContent } from './useAllessehContentQuery';

export const getAllessehContentByOriginId = (authToken: string, originId: string) =>
  restClient.get<AllessehContent>(`allesseh/contentEndpoint?originId=${originId}`, {
    headers: { Authorization: authToken }
  });

export const useAllessehContentByOriginIdQuery = (
  originId: string,
  options?: { enabled?: boolean }
): { data: AllessehContent | undefined; isLoading: boolean } => {
  const authToken = useAuthToken();

  const result = useAppQuery(
    ['allessehContentByOriginId', originId],
    () => getAllessehContentByOriginId(authToken, originId),
    options
  );

  return {
    data: result.data,
    isLoading: result.isLoading
  };
};
